export const countryOptions = [
  { label: 'United States (+1)',   code: '+1',  length: 10 },
  { label: 'Canada (+1)',          code: '+1',  length: 10 },
  { label: 'New Zealand (+64)',    code: '+64', length: 9  },
  { label: 'Australia (+61)',      code: '+61', length: 9  },
  { label: 'China (+86)',          code: '+86', length: 11 }
];

export const extractCountryCode = (label) => {
  const m = label.match(/\((\+\d+)\)/);
  return m ? m[1] : '';
};

export const validatePhoneNumber = (label, raw) => {
  const cc = extractCountryCode(label);
  const digits = raw.replace(/\D/g, '');
  const opt = countryOptions.find(o => o.code === cc);
  if (!opt) return `Unsupported country code ${cc}.`;
  const country = opt.label.split(' (')[0];
  if (digits.length !== opt.length) {
    return `Phone number must be ${opt.length} digits for ${country}.`;
  }
  return '';
};

export const stripCountryCode = (full) => {
  const digits = full.replace(/\D/g, '');
  for (const o of countryOptions) {
    const codeDigits = o.code.replace('+','');
    if (digits.startsWith(codeDigits)) {
      return digits.slice(codeDigits.length);
    }
  }
  return digits; 
};

export const getMaskedNumber = (full) => {
  const digits = full.replace(/\D/g, '')
  let cc = ''
  let national = ''
  for (const o of countryOptions) {
    const cd = o.code.replace('+', '')
    if (digits.startsWith(cd)) {
      cc = o.code
      national = digits.slice(cd.length)
      break
    }
  }
  if (!cc) {
    cc = '+' + digits.charAt(0)
    national = digits.slice(1)
  }
  const last4 = national.slice(-4)
  const maskedPrefix = '*'.repeat(Math.max(0, national.length - 4))

  return `${cc} ${maskedPrefix}${last4}`
}
